import React from 'react'
import {useIntl} from 'react-intl'
import {useAutomationRulesData} from '../../../hooks'

type Props = {
  option: any
  isSelected?: boolean
  context?: 'menu' | 'value'
}

export const AddressOptionLabel: React.FC<Props> = ({option, isSelected, context}) => {
  const intl = useIntl()
  const {shipFromAddresses} = useAutomationRulesData()
  const liveAddr = shipFromAddresses.find((a: any) => a.id === option.value)
  const addr = liveAddr ?? option._addr

  if (!addr) return <>{option.label}</>

  const name = addr.company || `${addr.first_name || ''} ${addr.last_name || ''}`.trim()
  const addressStr = [addr.street1, addr.city, addr.state, addr.zip].filter(Boolean).join(', ')
  const isWhite = isSelected && context === 'menu'
  const isDeleted = !liveAddr && !!option._addr

  return (
    <div className='d-flex flex-column'>
      {name && <div className='fw-bold'>{name}</div>}
      <div className={isWhite ? 'text-white fs-7' : 'text-muted fs-7'}>
        {addressStr}
        {isDeleted && ` (${intl.formatMessage({id: 'NOT_FOUND'})})`}
      </div>
    </div>
  )
}
